"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IterableMap = void 0;
const SafeMap_1 = require("./SafeMap");
const ChainableIterator_1 = require("./ChainableIterator");
class IterableMap extends SafeMap_1.SafeMap {
    iterKeys() {
        return new ChainableIterator_1.ChainableIterator(super.keys());
    }
    iterValues() {
        return new ChainableIterator_1.ChainableIterator(super.values());
    }
    iterEntries() {
        return new ChainableIterator_1.ChainableIterator(super.entries());
    }
    static from(entries) {
        return new IterableMap(entries);
    }
}
exports.IterableMap = IterableMap;
//# sourceMappingURL=IterableMap.js.map